export default __webpack_public_path__ + "media/images/testimonials/egg-bg-889db89a6401af67dd13a64b2264c8ac.png";